var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_vm.order ? _c("el-alert", {
    attrs: {
      type: "info",
      closable: false
    }
  }, [_vm._v(" Grand total: " + _vm._s(_vm.order.grandTotal) + " "), _c("br"), _vm._v(" Payable amount: " + _vm._s(_vm.payableAmount) + " ")]) : _vm._e(), _c("br"), _vm.payableAmount > 0 ? _c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "UTR Number",
      prop: "utrNumber"
    }
  }, [_c("el-input", {
    attrs: {
      name: "utrNumber",
      required: "",
      placeholder: "UTR Number"
    },
    model: {
      value: _vm.formData.utrNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "utrNumber", $$v);
      },
      expression: "formData.utrNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Amount",
      prop: "amount"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "amount",
      precision: 2,
      step: 1,
      min: 1,
      max: _vm.payableAmount,
      placeholder: "Amount"
    },
    model: {
      value: _vm.formData.amount,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "amount", $$v);
      },
      expression: "formData.amount"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Transaction Date",
      prop: "transactionDate"
    }
  }, [_c("el-date-picker", {
    attrs: {
      name: "transactionDate",
      type: "date",
      placeholder: "Pick a day",
      format: "dd-MM-yyyy",
      "picker-options": {
        disabledDate: _vm.isDateAllowed
      }
    },
    model: {
      value: _vm.formData.transactionDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "transactionDate", $$v);
      },
      expression: "formData.transactionDate"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Bank",
      prop: "bank"
    }
  }, [_c("el-input", {
    attrs: {
      name: "bank",
      required: "",
      placeholder: "Enter bank name"
    },
    model: {
      value: _vm.formData.bank,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "bank", $$v);
      },
      expression: "formData.bank"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Status",
      prop: "status"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      name: "status",
      placeholder: "Select"
    },
    model: {
      value: _vm.formData.status,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "status", $$v);
      },
      expression: "formData.status"
    }
  }, _vm._l(["pending", "success", "failed"], function (item) {
    return _c("el-option", {
      key: item,
      attrs: {
        required: "",
        label: item,
        value: item
      }
    });
  }), 1)], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };